


































import DatasourceServices from '@/services/datasource';
import { DataprocessDto } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {  }
})
export default class DataprocessFlinksql7 extends Vue {
  @PropSync('formData') syncFormData!: DataprocessDto;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;

  dsSrv = new DatasourceServices();
  activeKey: string = '0';
  expandIconPosition: string = 'left';

  dsTypeList = [
      {key: 'doris', value: 'doris'}
  ];
  dsObjList: any[] = [];

  mounted() {
    this.getDsList();
  }

  async onChangeDsType(e: string, index: number) {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    let v = this.syncFormData.sourcesDsConfig[index];
    v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number, index: number) {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    let v = this.syncFormData.sourcesDsConfig[index];
    v.sourceDsId = e;
    let datatsource = v.dsList.filter((v: any) => v.id == e);
    v.sourceDsName = datatsource && datatsource.length > 0 ? datatsource[0].dsName : '';
    if(!v.sourceDsType) { v.sourceDsType = datatsource[0].dsType; } 
    this.$forceUpdate();
  }

  @Watch('syncFormData.id')
  async getDsList() {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    if (this.syncFormData.id) {
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
          let v = this.syncFormData.sourcesDsConfig[i];
          v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: v.sourceDsType });
          v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: v.sourceDsId });
      }
    } else {
      let ret = await this.dsSrv.getList({ status_eq: 0, dsType_eq: '' });
      this.dsObjList = ret;
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
          this.syncFormData.sourcesDsConfig[i].dsList = ret;
      }
    }
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  handleClick(index: number) {
    this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig.splice(index, 1);
  }

  @Watch('syncFormData.sourcesDsConfig.length')
  onFormDataChange(newVal: number, oldVal: number) {
    debugger
    if(newVal !== oldVal) {
      let index = newVal - 1;
      this.activeKey = '' + index ;
      // this.$nextTick(() => {
      //   this.activeKey = '' + index ;
      // });
    }
  }

  addSource() {
    if (this.syncFormData.sourcesDsConfig) {
      this.syncFormData.sourcesDsConfig.push({
        sourceDsId: 0,
        sourceDsType: '',
        sourceDsName: '',
        sourceDsTableName: '',
        sourceDsTableLogicName: '',
        sourceDsColumns: [],
        // 偏移量类型:0-最新记录,1-最早记录,2-自定义参数
        //startMode: 0,
        // 自定义偏移量
        startLocation: '',
        incrementColumn: '',
        incrementColumnType: '',
        restoreColumn: '',
        restoreColumnType: '',
        kafkaGroupId: '',
        // 时间特征 0-处理时间，1-事件时间
        timeFlag: 0,
        // 时间字段名称
        timeColumn1: '',
        timeColumn2: '',
        // Watermark值与Event Time值的偏移量，单位为毫秒
        timeOffset: 0,
        parallelism: 1,
        dsList: this.dsObjList,
        tableList: [],
      });
    }
  }

  removeList(index1: number, index2: number) {
    this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig[index1].sourceDsColumns?.splice(index2, 1);
  }

  async confirm() {
    const must: { field: 'sourceDsId' | 'sourceDsType' | 'sourceDsName' ; msessage: string }[] = [
        { field: 'sourceDsId', msessage: '源数据源不能为空' },
        { field: 'sourceDsType', msessage: '源数据源类型不能为空' },
        { field: 'sourceDsName', msessage: '源数据源不能为空' }
    ];
    if (this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig.length > 0) {
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
        let v = this.syncFormData.sourcesDsConfig[i];
        for (let val of must) {
          if (!v[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
        
        if (this.syncFormData.jobConfig) {
            if (v.pollingInterval && v.pollingInterval > 0) {
              this.syncFormData.jobConfig.jobType = 1;
            }
        }
      }
    }

    this.syncVisible = false;
    return true;
  }

}
